import {
	TRANSACTION_CHANNEL,
	TRANSACTION_CREATED,
  TRANSACTION_UPDATED,
  ACCESS_PROVISION_BEGAN,
} from "./utils/channel-names";
import type { Events, EventMessage } from "./utils/types.ds";

interface IChannelEvents {
	setNotifications?: (prev) => void;
	userEmail: string;
	setNewNotification?: (val) => void;
}

export default ({
	setNotifications,
	setNewNotification,
	userEmail,
}: IChannelEvents) =>
	[
		{
			channel: `${TRANSACTION_CHANNEL}_${userEmail}`,
			channelEvents: [
				{
					eventName: TRANSACTION_CREATED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === TRANSACTION_CREATED
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: TRANSACTION_UPDATED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === TRANSACTION_UPDATED
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: ACCESS_PROVISION_BEGAN,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === ACCESS_PROVISION_BEGAN
							? setNewNotification(data)
							: null;
					},
				},
			],
		}
	] as Events[];


export const createNotficationMessage = (data: EventMessage) => {
	const eventTitleMap = {
    "createTransaction": "Transaction created",
    "updateTransaction": "Transaction updated",
    "accessProvisioningBegan": "Processing Access Request",
    "accessProvisioningSuccess": "Access Request Approved",
    "accessProvisioningFailed": "Access Request Failed"
  }
  const eventTitle = eventTitleMap[data.event]

	return {
		id: +Date.now(),
		title: eventTitle,
		description: "",
		read: false,
	};
};
